export function extractPhoneDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export function normalizePhoneDigits(value: string): string {
  return extractPhoneDigits(value).replace(/^0+/, '');
}
